<script setup lang="ts">
  import { computed } from 'vue';
  import { TabsMenu } from '@/shared/ui';
  import { useRouter } from 'vue-router';

  const OPTIONS = [
    {
      id: 'permissoes',
      text: 'Permissões',
    },
    {
      id: 'atribuicoes',
      text: 'Atribuições',
    },
  ];

  const router = useRouter();
  const currentRoute = computed(() => router.currentRoute.value.path);

  const selectedOption = computed(() => currentRoute.value.split('/').pop() || 'permissoes');
  const shouldShowTabsHeader = computed(() => selectedOption.value !== 'listar');

  const handleOptionSelect = (optionId: string) => {
    router.push(`/admin/permissoes/${optionId}`);
  };
</script>

<template>
  <div
    data-testid="admin-permissions-page"
    class="pt-4 p-6"
  >
    <template v-if="shouldShowTabsHeader">
      <h3 class="text-gray-07 text-xl/7.5 font-semibold text-left mb-6">
        Permissões
      </h3>

      <TabsMenu
        :options="OPTIONS"
        :selected-option="selectedOption"
        @option-selected="handleOptionSelect"
      />
    </template>

    <router-view />
  </div>
</template>
